// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2JkKW","NoScroll":"App_NoScroll__3hZRS"};